var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useIphoneX } from "./use-iphonex";
export var Footer = function (_a) {
  var _b = _a.styles,
      styles = _b === void 0 ? {} : _b,
      _c = _a.className,
      className = _c === void 0 ? "" : _c,
      _d = _a.container,
      container = _d === void 0 ? document.body : _d,
      _e = _a.block,
      block = _e === void 0 ? false : _e,
      children = _a.children;
  var isIphonex = useIphoneX()[0];
  var footerRef = useRef(null);

  var _f = useState(0),
      height = _f[0],
      setHeight = _f[1];

  useLayoutEffect(function () {
    var _a, _b;

    setHeight((_b = (_a = footerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.height);
  }, [children]);
  var blockOptions = block;
  return React.createElement(React.Fragment, null, block ? createPortal(React.createElement("div", {
    className: (blockOptions === null || blockOptions === void 0 ? void 0 : blockOptions.className) || "",
    style: __assign({
      width: "100vw",
      height: "".concat(height, "px")
    }, (blockOptions === null || blockOptions === void 0 ? void 0 : blockOptions.styles) || {})
  }), container) : null, React.createElement("div", {
    className: className,
    style: __assign({
      position: "fixed",
      bottom: 0,
      left: 0,
      width: "100vw",
      paddingBottom: isIphonex ? "".concat(34, "px") : 0
    }, styles),
    ref: footerRef
  }, children));
};